import * as moment from 'pkp-moment-timezone-all-years';
import * as angular from 'angular';
import { AuthService } from 'app/_services/auth.service';
import { config, reactShell } from 'angular/utils/config';

export class ProposalDetailsCtrl implements ng.IController {
    public PROPOSAL_RESPONSE_PAGE =
        'app/proposal-details/proposal-response.html';
    public proposal: any = {};

    public id: number;
    public TRANSACTION_TYPE;
    public PROCEDURE_TYPE;
    public PROPOSAL_TYPE;

    public respond = false;
    public typ = '';
    public isRespondErrorPost = false;
    public acceptRespond = {};
    public rejectId = undefined;
    public isAcceptResponse = false;
    public isSubmitted = false;
    public isTraderListDeleted = false;
    public isCompleteRuntime = null;
    public isLoggedIn = false;

    public REST_CONTEXT = config.monolithApi;
    public uiLoading = true;
    public errorMessage = '';
    public proposalToSellCreatedEvent = 'proposal-details_sell_create_success';
    public proposalToBuyCreatedEvent = 'proposal-details_buy_create_success';
    public proposalToSellSavedEvent = 'proposal-details_sell_save_success';
    public proposalToBuySavedEvent = 'proposal-details_buy_save_success';
    public successEventsFired = false;

    public responseSubmittedEvent =
        'proposal-details_response_submitted_success';
    public responseAcceptedEvent = 'proposal-details_response_accepted_success';
    public responseRejectedEvent = 'proposal-details_response_rejected_success';
    public responseWithdrawnEvent =
        'proposal-details_response_withdrawn_success';

    public proposalDeletedEvent = 'proposal-details_delete_success';
    public proposalWithdrawnEvent = 'proposal-details_withdrawal_success';

    public pendingResponses = 0;
    public formSubmitting = false;
    public exchangeRate: any = {};
    public config: any = {};

    public tsoConfig = [];
    public withdrawnId;
    public balancingCodeInfo;

    public proposalDeletedSuccessfully;
    public proposalWithdrawnSuccessfully;

    public remitSupport;

    constructor(
        private $window: ng.IWindowService,
        private $log: ng.ILogService,
        private $location: ng.ILocationService,
        private $routeParams: ng.route.IRouteParamsService,
        private $rootScope: ng.IRootScopeService,
        private $timeout: ng.ITimeoutService,
        private DATES,
        private API_URL,
        private TradeProposals,
        private activitiesService,
        private createProposalService,
        private authService: AuthService
    ) {
        this.id = $routeParams.id;
        this.TRANSACTION_TYPE = activitiesService.TRANSACTION_TYPE;
        this.PROCEDURE_TYPE = activitiesService.PROCEDURE_TYPE;
        this.PROPOSAL_TYPE = activitiesService.PROPOSAL_TYPE;

        authService.getLoggedInUserAsync().then((loggedInUser) => {
            this.isLoggedIn = !!loggedInUser;

            if (this.isLoggedIn) {
                TradeProposals.remitSupport(undefined, (res) => {
                    this.remitSupport = res;
                });
            }
        });

        this.fetchProposal();

        this.proposalDeletedSuccessfully = !angular.isUndefined(
            this.proposalDeletedSuccessfully
        );
        this.proposalWithdrawnSuccessfully = !angular.isUndefined(
            this.proposalWithdrawnSuccessfully
        );
    }

    public fetchProposal() {
        const param = {
            id: this.id
        };

        this.uiLoading = true;

        return this.TradeProposals.get(
            param,
            (res) => {
                this.proposal = res;

                if (this.isLoggedIn) {
                    this.fetchConfig();
                } else {
                    this.uiLoading = false;
                }
                if (res.proposalType.indexOf('BUY') > -1) {
                    this.typ = 'buy';
                } else {
                    this.typ = 'sell';
                }
                if (this.proposal.actions.indexOf('RESPOND') >= 0) {
                    this.respond = true;
                }

                this.isCompleteRuntime =
                    this.createProposalService.isCompleteRuntime(
                        this.proposal.runtime,
                        this.proposal.minimumLotRuntime
                    );
                this.pendingResponses = this.updatePendingResponses();
                this.updateExchangeRate();
            },
            () => {
                this.formSubmitting = false;
            }
        ).$promise;
    }

    public updatePendingResponses() {
        let result = 0;

        if (!this.proposal.responseList) {
            return result;
        }

        let i = 0;
        for (; i < this.proposal.responseList.length; i++) {
            if (
                this.proposal.responseList[i].state === 'PENDING' ||
                this.proposal.responseList[i].state === 'APPROVED_EXIT' ||
                this.proposal.responseList[i].state === 'APPROVED_ENTRY'
            ) {
                result++;
            }
        }
        return result;
    }

    public updateExchangeRate() {
        if (
            !angular.isUndefined(this.proposal.components[0]) &&
            !angular.isUndefined(this.proposal.components[0].exchangeRate)
        ) {
            this.updateExchangeRateFromPrice(
                this.proposal.components[0].exchangeRate
            );
        }
        if (
            !angular.isUndefined(this.proposal.components[1]) &&
            !angular.isUndefined(this.proposal.components[1].exchangeRate)
        ) {
            this.updateExchangeRateFromPrice(
                this.proposal.components[1].exchangeRate
            );
        }
    }

    public updateExchangeRateFromPrice(xchgRate) {
        if (
            !angular.isUndefined(this.proposal.price.originalUnit) &&
            this.proposal.price.originalUnit.currency === xchgRate.isoCode
        ) {
            this.exchangeRate = {
                value: xchgRate.rate,
                unit: 'EUR/' + xchgRate.isoCode,
                date: moment(xchgRate.validity.start).format('DD.MM.YYYY HH:mm')
            };
        }
    }

    public fetchConfig() {
        return this.TradeProposals.tsoConfig(
            {
                networkPointId: this.proposal.networkPoint.id
            },
            (res) => {
                this.config = res;
                this.mapConfig();
            }
        ).$promise.finally(() => {
            this.uiLoading = false;
            this.formSubmitting = false;

            this.$timeout(() => this.showSuccessNotifications(), 500);
        });
    }

    public mapConfig() {
        this.tsoConfig = [this.buildTsoConfig(0)];
        if (this.proposal.networkPoint.bundled) {
            this.tsoConfig[1] = this.buildTsoConfig(1);
        }
    }

    public buildTsoConfig(index) {
        const tsoConfig = this.config['tso' + index + 'Config'];
        return this.createProposalService.buildTsoConfig(
            index,
            tsoConfig,
            this.balancingCodeInfo
        );
    }

    public showSuccessNotifications() {
        const queryParams = this.$location.search();
        if (queryParams.hasOwnProperty('action') && !this.successEventsFired) {
            if (
                queryParams.action ===
                this.createProposalService.WIZARD_ACTION.CREATE
            ) {
                if (this.typ === 'buy') {
                    this.$rootScope.$broadcast(this.proposalToBuyCreatedEvent);
                } else {
                    this.$rootScope.$broadcast(this.proposalToSellCreatedEvent);
                }
            } else if (
                queryParams.action ===
                this.createProposalService.WIZARD_ACTION.DRAFT
            ) {
                if (this.typ === 'buy') {
                    this.$rootScope.$broadcast(this.proposalToBuySavedEvent);
                } else {
                    this.$rootScope.$broadcast(this.proposalToSellSavedEvent);
                }
            }
            this.successEventsFired = true;
        }

        if (
            queryParams.action ===
            this.createProposalService.DETAIL_PAGE_ACTION.CREATE_RESPONSE
        ) {
            this.$rootScope.$broadcast(this.responseSubmittedEvent);
        }

        if (this.isAcceptResponse) {
            this.isAcceptResponse = false;
            this.$window.scrollTo(0, 0);
            this.$rootScope.$broadcast(this.responseAcceptedEvent);
        }

        if (this.proposalDeletedSuccessfully) {
            this.proposalDeletedSuccessfully = false;
            this.$window.scrollTo(0, 0);
            this.$rootScope.$broadcast(this.proposalDeletedEvent);
        }

        if (this.proposalWithdrawnSuccessfully) {
            this.proposalWithdrawnSuccessfully = false;
            this.$window.scrollTo(0, 0);
            this.$rootScope.$broadcast(this.proposalWithdrawnEvent);
        }
    }

    public rejectResponse(responseId, index) {
        const param = {
            id: this.id,
            responseId: responseId
        };
        this.TradeProposals.rejectResponse(param, () => {
            this.rejectId = this.proposal.responseList[index].id;
            this.proposal.responseList[index].actions = undefined;
            this.proposal.responseList[index].state = 'CANCELLED';
            this.$window.scrollTo(0, 0);
            this.$rootScope.$broadcast(this.responseRejectedEvent);
        });
    }

    public acceptResponse(responseId) {
        const param = {
            id: this.id,
            responseId: responseId
        };
        this.TradeProposals.acceptRespond(
            param,
            (res) => {
                this.acceptRespond = {
                    id: res.id,
                    amount: res.amount,
                    price: res.price,
                    runtime: res.runtime
                };
                this.isAcceptResponse = true;
                this.errorMessage = '';
                this.fetchProposal();
            },
            (res) => {
                this.isAcceptResponse = false;
                this.errorMessage = res.data.message;
                this.$log.error(res);
                this.$window.scrollTo(0, 0);
            }
        );
    }

    public deleteProposal() {
        const param = {
            id: this.id
        };

        this.TradeProposals.delete(param, () => {
            if (this.proposal.state === 'NEW') {
                this.proposalDeletedSuccessfully = true;
            } else {
                this.proposalWithdrawnSuccessfully = true;
            }
            this.fetchProposal();
        });
    }

    public deleteResponse(responseId, index) {
        const param = {
            id: this.id,
            responseId: responseId
        };

        this.TradeProposals.rejectResponse(param, () => {
            this.proposal.responseList[index].actions = undefined;
            this.proposal.responseList[index].state = 'CANCELLED';
            this.withdrawnId = responseId;
            this.$window.scrollTo(0, 0);
            this.$rootScope.$broadcast(this.responseWithdrawnEvent);
        });
    }

    public downloadConditions() {
        const URL =
            this.API_URL.PROPOSAL +
            '/' +
            this.proposal.id +
            '/tradingConditions';
        reactShell.downloadFile(URL);
    }

    public submitProposal() {
        const param = {
            id: this.id
        };
        this.TradeProposals.submitProposal(param, () => {
            this.isSubmitted = true;
            this.fetchProposal();
        });
    }

    public removeTraderList() {
        const param = {
            id: this.id
        };
        this.TradeProposals.removeTraderList(param, () => {
            this.fetchProposal();
            this.isTraderListDeleted = true;
        });
    }
}

angular.module('app').controller('ProposalDetailsCtrl', ProposalDetailsCtrl);
